import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Kontekst} from "felles/tjenester/Kontekst";
import {EnkelGruppeModell, GruppeId, OppsettModell} from "./ressurser/generertNg2HttpKlient";
import {BrukerkontekstTilbyder} from "./BrukerkontekstTilbyder";
import {Injectable} from "@angular/core";

const debug = initDebugger('Gruppeoppsett');

/**
 * Gir tilgang til oppsett for de grupper bruker har tilgang til.
 * Denne informasjonen er også tilgjengelig via {@link Brukerkontekst} men vi eksponerer oppsett-delen av gruppeinformasjonen
 * eksplisitt her for bedre å håndtere mutering av valgene i oppsett.
 */
@Injectable({providedIn: 'root'})
export class Gruppeoppsett {

    constructor(private kontekstTilbyder: BrukerkontekstTilbyder, private ajsKontekst: Kontekst) {
    }

    oppsettForGruppe(id: GruppeId): OppsettModell {
        return this.gruppe(id).oppsett;
    }

    /** Sørger for å reflektere endring i oppsett.sorterSakerEtterSakstype i lokal modell.
     * Merk at vi her ikke oppdaterer gruppe.oppsett på serversiden. */
    oppdaterSorterSakerEtterSakstype(id: GruppeId, nyVerdi: boolean) {
        this.gruppe(id).oppsett.sorterSakerEtterSakstype = nyVerdi;
        this.ajsKontekst.finnAutentiserteGruppe(id).oppsett.sorterSakerEtterSakstype = nyVerdi; //enn så lenge må vi sørger for å oppdatere ajs-representasjonen også
    }

    //hjelpemetoder

    private gruppe(id: string): EnkelGruppeModell {
        return this.kontekstTilbyder.autentisertBruker().finnAutentiserteGruppe(id)!;
    }

}
